"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = arrayPluck;
/**
 *
 * @param {Array} array
 * @param {string|number} propertyName The property of the
 * @returns {Array}
 *
 * @throws {TypeError} When the `propertyName` can not be found on an item in the `array`. This generally happens when a value in the array is `null` or `undefined`
 *
 * @example
 * const values = [{name: 'John'}, {name: 'James'}];
 * arrayPluck(values, 'name') // returns: ['John', 'James']
 *
 * @example
 * const values = [{name: 'John'}, {}, {name: 'James'}];
 * arrayPluck(values, 'name') // returns: ['John', undefined, 'James']
 *
 * @example
 * const values = [undefined, {name: 'James'}];
 * arrayPluck(values, 'name') // throws: Cannot read property 'name' of undefined
 */
function arrayPluck(array, propertyName) {
    var newArray = [];
    var i;
    var len;
    var item;

    for (i = 0, len = array.length; i < len; i++) {
        item = array[i];

        newArray.push(item[propertyName]);
    }

    return newArray;
}
//# sourceMappingURL=arrayPluck.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/~/d2-utilizr/lib/arrayPluck.js
 ** module id = 24
 ** module chunks = 0 1
 **/